module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-6-93f3cdefe8572a27a78055cdbd78196d.svg";